export { PROGRAMMING_ROUTES } from './src/app/programming.routes';
export { PROGRAMMING_REDUCERS } from './src/app/programming.stores';
export { ProgrammingModule } from './src/app/programming.module';
export { ProgrammingRoutingModule } from './src/app/programming.routes';
export { ProgrammingComponent } from './src/app/programming.component';



// WEBPACK FOOTER //
// ./~/@c4/programming/index.ts